import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss']
})
export class RichTextComponent implements OnInit {

  @Input() text: string = "";
  parts: string[] = [];
  boldSign: string = "**";

  constructor() { }

  ngOnInit() {
    if(!this.text) return;
    this.parts = this.formParts(this.text);
  }

  isBold(part: string) : boolean {
    if(!part) return false;
    if(part.length < 2) return false;
    return part.startsWith(this.boldSign);
  }

  getBoldPart(part: string): string {
    if(!part) return "";
    return part.substring(2, part.length - 2);
  }

  getAllIndexes(text: string, val: string): number[] {
      let indexes: number[] = [];
      let i: number = -1;
      while ((i = text.indexOf(val, i+1)) != -1){
          indexes.push(i);
      }
      return indexes;
  }

  formParts(text: string): string[] {

    let indexes: number[] = this.getAllIndexes(this.text, this.boldSign);

    if(!text || !indexes || indexes.length %2 != 0) return [];
    let parts: string[] = [];
    parts.push(text.substring(0, indexes[0]));
    let i = 0;
    for(i; i < indexes.length - 1; i++) {
      if(i % 2 == 0) {
        parts.push(text.substring(indexes[i], indexes[i+1] + this.boldSign.length));
      }
      else {
        parts.push(text.substring(indexes[i] + this.boldSign.length, indexes[i+1]));
      }

    }
    parts.push(text.substring(indexes[i] + this.boldSign.length));

    return parts;
  }


}
